export const workoutPrograms = [
  {
    name: "Push Workout",
    exercises: [
      {
        name: "Barbell Bench Press",
        sets: 5,
        reps: 6,
        restSeconds: 150,
        startWeight: 135,
        increment: 5,
        isBarbell: true,
        notes: "Increase weight by 5 lbs when you complete all sets"
      },
      {
        name: "Weighted Dips",
        sets: 4,
        reps: 8,
        restSeconds: 120,
        startWeight: 0,
        increment: 5,
        isBarbell: false,
        notes: "Start bodyweight if needed, add 5 lbs when you hit all reps"
      },
      {
        name: "Seated Overhead Barbell Press",
        sets: 4,
        reps: 8,
        restSeconds: 120,
        startWeight: 65,
        increment: 5,
        isBarbell: true,
        notes: "Increase by 5 lbs when all reps are completed"
      }
    ]
  },
  {
    name: "Pull Workout",
    exercises: [
      {
        name: "Pull-Ups",
        sets: 5,
        reps: 8,
        restSeconds: 150,
        startWeight: 0,
        increment: 5,
        isBarbell: false,
        notes: "Full range: dead hang to chin over bar"
      },
      {
        name: "Barbell Rows",
        sets: 4,
        reps: 10,
        restSeconds: 120,
        startWeight: 95,
        increment: 5,
        isBarbell: true,
        notes: "45° torso angle, pull bar to lower ribs"
      },
      {
        name: "Barbell Curls",
        sets: 3,
        reps: 10,
        restSeconds: 90,
        startWeight: 45,
        increment: 5,
        isBarbell: true,
        notes: "Keep upper arms stationary against torso"
      }
    ]
  },
  {
    name: "Upper Body Workout",
    exercises: [
      {
        name: "Incline Barbell Bench Press",
        sets: 4,
        reps: 8,
        restSeconds: 150,
        startWeight: 115,
        increment: 5,
        isBarbell: true,
        notes: "Set bench to 30° incline, bar to upper chest"
      },
      {
        name: "Low Rows",
        sets: 4,
        reps: 10,
        restSeconds: 120,
        startWeight: 90,
        increment: 5,
        isBarbell: false,
        notes: "Pull handle to lower abdomen, squeeze for 1 second"
      },
      {
        name: "Close-Grip Bench Press",
        sets: 4,
        reps: 10,
        restSeconds: 120,
        startWeight: 95,
        increment: 5,
        isBarbell: true,
        notes: "Grip width: 14-16 inches between hands, keep elbows tucked"
      }
    ]
  }
];

// Default to the first workout for backwards compatibility
export const workoutProgram = workoutPrograms[0];